import {
	AppBar,
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	Drawer,
	Grid,
	IconButton,
	TextField,
	Toolbar,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import '../App.css';
import Banner1 from '../images/banner1.jpg';

import { styled } from '@mui/material/styles';
import Banner2 from '../images/banner2.jpg';
import Banner3 from '../images/banner3.jpg';
import logo from '../images/logo.jpg';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import { scroller } from "react-scroll"; // Import scroller for smooth scrolling


const StyledButton = styled(Button)(({ theme }) => ({
	backgroundColor: '#008345',
	color: '#fff',
	// textTransform: 'uppercase',
	fontWeight: 'bold',
	padding: '15px 0px',
	marginTop: '30px',
	border: '2px solid #FF0000',
	transition: 'all 0.3s ease',
	'&:hover': {
		backgroundColor: 'transparent',
		color: '#fff',
		borderColor: '#FF0000',
	},
}));

const Banner = () => {
	const navigation = ['Home', 'Accommodation', 'Meeting And Events', 'Gallery'];
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [contactModalOpen, setContactModalOpen] = useState(false);

	// Set default dates to today's date
	const [checkInDate, setCheckInDate] = useState(new Date());
	const [checkOutDate, setCheckOutDate] = useState(new Date());

	const [showAnimation, setShowAnimation] = useState(true); // State to control animation
	const [lastScrollTop, setLastScrollTop] = useState(0); // Track last scroll position
	const navigate = useNavigate(); // Initialize the navigate function


	useEffect(() => {
		const handleScroll = () => {
		  const currentScrollTop = window.scrollY;
	
		  // Check if scrolling up
		  if (currentScrollTop < lastScrollTop) {
			setShowAnimation(true); // Trigger animation
		  } else {
			setShowAnimation(false); // Hide animation
		  }
	
		  setLastScrollTop(currentScrollTop);
		};
	
		window.addEventListener("scroll", handleScroll);
		return () => {
		  window.removeEventListener("scroll", handleScroll);
		};
	  }, [lastScrollTop]);
	

	const toggleDrawer = open => () => {
		setDrawerOpen(open);
	};

	const toggleContactModal = open => () => {
		setContactModalOpen(open);
	};

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: true,
		customPaging: i => (
			<Box
				sx={{
					width: '10px',
					height: '10px',
					borderRadius: '50%',
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
					opacity: 0.7,
					'&:hover': { opacity: 1 },
				}}
			/>
		),
		dotsClass: 'slick-dots slick-thumb',
	};

	const banners = [Banner1, Banner2, Banner3];

	const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
	const [cursorScale, setCursorScale] = useState(false);

	useEffect(() => {
		const moveCursor = e => {
			setCursorPosition({ x: e.clientX, y: e.clientY });
		};

		const enlargeCursor = () => setCursorScale(true);
		const shrinkCursor = () => setCursorScale(false);

		window.addEventListener('mousemove', moveCursor);
		document.querySelectorAll('a, button').forEach(el => {
			el.addEventListener('mouseenter', enlargeCursor);
			el.addEventListener('mouseleave', shrinkCursor);
		});

		return () => {
			window.removeEventListener('mousemove', moveCursor);
			document.querySelectorAll('a, button').forEach(el => {
				el.removeEventListener('mouseenter', enlargeCursor);
				el.removeEventListener('mouseleave', shrinkCursor);
			});
		};
	}, []);

	return (
		<>
			{/* Custom Cursor */}
			<div
				className={`custom-cursor ${cursorScale ? 'cursor-large' : ''}`}
				style={{
					top: `${cursorPosition.y}px`,
					left: `${cursorPosition.x}px`,
				}}></div>

			<AppBar
				position='absolute'
				sx={{
					top: '0',
					backgroundColor: 'transparent',
					boxShadow: 'none',
				}}>
				<Toolbar
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						px: { xs: 2, sm: 4 },
						py: { xs: 1, sm: 2 },
					}}>
					{/* Logo Section */}
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Link to="#" style={{ textDecoration: "none" , color: 'black'}}>
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "80px",
                marginRight: "20px",
              }}
            /> </Link>
					</Box>

					{/* Navigation Menu */}
					<Box
						sx={{
							display: { xs: 'none', md: 'flex' }, // Hide menu on small screens
							flexDirection: { sm: 'row' },
							alignItems: 'center',
							// gap: { xs: "10px", sm: "20px" },
							// padding: { xs: "4px", sm: "8px 16px" },
							backgroundColor: '#f9f9f9',
							height: "45px",
							borderRadius: '8px',
							animation: showAnimation ? "slideIn 0.6s ease-out" : "none", // Apply animation based on state
							"@keyframes slideIn": {
							  "0%": {
								transform: "translateX(100%)",
								opacity: 0,
							  },
							  "100%": {
								transform: "translateX(0)",
								opacity: 1,
							  },
							},
						}}>
						<Box
							sx={{
								display: 'flex',
								flexDirection: { sm: 'row' },
								gap: '10px',
								height: "45px",
								

							}}>
							{navigation.map((item, index) => (
								<Typography
								  key={index}
								  variant="body1"
								  onClick={() => {
									if (item === "Accommodation") {
									  navigate("/accomodation"); 
									  }
									  if (item === "Meeting And Events") {
										navigate("/meetingEvents"); 
									  }
									  if (item === "Gallery") {
      									  scroller.scrollTo("gallery-section", {
        								  duration: 800, 
       									  delay: 0,
        								  smooth: "easeInOutQuart", 
      									});
										}
								  }}
								  sx={{
									color: 'black',
									fontWeight: 500,
									padding: '10px 15px',
									cursor: 'pointer', // Add pointer cursor for better UX
									transition: 'all 0.3s ease',
									'&:hover': {
									  color: '#fff',
										// backgroundColor: '#008345',
										// pt:-8,
										backgroundColor: '#FF0000',
										height: "45px",
									  boxShadow: '8px 4px 8px rgba(0, 0, 0, 0.2)', 
									},
								  }}
								  style={{
									fontFamily: 'SangBleu Empire Trial',
									fontWeight: 'bold',
								  }}
								>
								  {item}
								</Typography>
							  ))}
							  
						</Box>

						

						<Button
							sx={{
								//  color: "black",
								fontFamily: 'SangBleu Empire Trial',
								fontWeight: 'bold',

								padding: '10px 15px',
								transition: 'all 0.3s ease',
								backgroundColor: '#008345',
								textTransform: 'none',
								color: 'white',
								borderRadius: 0,
								'&:hover': {
									//  color: "#fff",
									backgroundColor: '#008345',
									// borderRadius: "4px",
									boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
								},
							}}
							style={{ fontWeight: 900 }}
							onClick={toggleContactModal(true)}>
							Contact
						</Button>
					</Box>

					{/* Contact Modal */}
					<Dialog
						open={contactModalOpen}
						onClose={toggleContactModal(false)}
						fullWidth
						maxWidth='md'>
						<DialogTitle
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								fontFamily: 'SangBleu Empire Trial',
								fontWeight: 'bold',
								pt: 2,
								pb: 1,
							}}>
							Contact Us
							<IconButton
								onClick={toggleContactModal(false)}
								sx={{ color: 'gray' }}>
								<CloseIcon />
							</IconButton>
						</DialogTitle>
						<DialogContent>
							<Box
								sx={{
									minWidth: '320px',
									maxHeight: '720px',
									borderRadius: 2,
									boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
								}}>
								<Grid
									container
									spacing={2}>
									{/* Left Section: Contact Information */}
									<Grid
										item
										xs={12}
										md={6}>
										<Box
											sx={{
												p: 3,
												borderRadius: 2,
												boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
												textAlign: 'center',
											}}>
											<Typography
												variant='h5'
												sx={{
													fontWeight: 'bold',
													textAlign: 'center',
													fontFamily: 'SangBleu Empire Trial',
												}}>
												{/* Contact Information */}
											</Typography>
											<Divider sx={{ mb: 2 }} />
											{/* Call Us Section */}
											<Box
												sx={{
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'center',
													mb: 3,
													p: 3,
													backgroundColor: '#f0f8f5',
													borderRadius: 2,
												}}>
												<Typography
													variant='h6'
													sx={{
														fontWeight: 'bold',
														fontFamily: 'SangBleu Empire Trial',
														color: '#333',
													}}>
													Call Us:
												</Typography>
												<Typography
													variant='body1'
													sx={{
														color: '#555',
														fontFamily: 'SangBleu Empire Trial',
													}}>
													01795-477977
												</Typography>
											</Box>
											{/* Email Us Section */}
											<Box
												sx={{
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'center',
													mb: 3,
													p: 3,
													backgroundColor: '#f0f8f5',
													borderRadius: 2,
												}}>
												<Typography
													variant='h6'
													sx={{
														fontWeight: 'bold',
														fontFamily: 'SangBleu Empire Trial',
														color: '#333',
													}}>
													Email Us:
												</Typography>
												<Typography
													variant='body1'
													sx={{
														color: '#555',
														fontFamily: 'SangBleu Empire Trial',
													}}>
													info@hotelcityplazabd.com
												</Typography>
											</Box>
											{/* Location Section */}
											<Box
												sx={{
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'center',
													p: 3,
													backgroundColor: '#f0f8f5',
													borderRadius: 2,
												}}>
												<Typography
													variant='h6'
													sx={{
														fontWeight: 'bold',
														fontFamily: 'SangBleu Empire Trial',
														color: '#333',
													}}>
													Location:
												</Typography>
												<Typography
													variant='body1'
													sx={{
														color: '#555',
														fontFamily: 'SangBleu Empire Trial',
													}}>
													Gohata Road, Jessore, Jessore, Bangladesh
												</Typography>
											</Box>
										</Box>
									</Grid>

									{/* Right Section: Contact Form */}
									<Grid
										item
										xs={12}
										md={6}>
										<Box
											sx={{
												p: 3,
												borderRadius: 2,
												boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
											}}>
											<Typography
												variant='h4'
												sx={{
													mb: 4,
													textAlign: 'center',
													fontFamily: 'SangBleu Empire Trial',
													fontWeight: 'bold',
												}}>
												{/* Contact Us */}
											</Typography>
											<TextField
												fullWidth
												label='Your Name'
												name='name'
												required
												sx={{ mb: 3, fontFamily: 'SangBleu Empire Trial' }}
											/>
											<TextField
												fullWidth
												label='Email Address'
												name='email'
												type='email'
												required
												sx={{ mb: 3 }}
											/>
											<TextField
												fullWidth
												label='Your Message'
												name='message'
												multiline
												rows={4}
												required
												sx={{ mb: 3 }}
											/>
											<Button
												type='submit'
												variant='contained'
												fullWidth
												sx={{
													py: 1.5,
													backgroundColor: '#008345',
													color: '#fff',
													fontFamily: 'SangBleu Empire Trial',
												}}>
												Send Message
											</Button>
										</Box>
									</Grid>
								</Grid>
							</Box>
						</DialogContent>
						{/* <DialogActions>
        <Button onClick={toggleContactModal(false)}>Cancel</Button>
      </DialogActions> */}
					</Dialog>

					{/* Drawer Menu Icon for Small Screens */}
					<IconButton
						edge='end'
						color='inherit'
						aria-label='menu'
						sx={{
							display: { xs: 'block', md: 'none' },
							color: 'white',
							// border: '2px #008345',
							// backgroundColor: 'white',
						}} // Only show on small screens
						onClick={toggleDrawer(true)}>
						<MenuIcon sx={{ borderRadius: 'none' }} />
					</IconButton>
				</Toolbar>
			</AppBar>

			<Drawer
				anchor='right'
				open={drawerOpen}
				onClose={toggleDrawer(false)}>
				<Box
					sx={{
						width: 250,
						padding: '16px',
						display: 'flex',
						flexDirection: 'column',
						gap: '16px',
					}}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<Typography variant='h6'>Menu</Typography>
						<IconButton onClick={toggleDrawer(false)}>
							<CloseIcon />
						</IconButton>
					</Box>

					{navigation.map((item, index) => (
						<Typography
							key={index}
							variant='body1'
								onClick={() => {
									if (item === "Accommodation") {
									  navigate("/accomodation"); // Redirect to the Accommodation page
									  }
									  if (item === "Meeting And Events") {
										navigate("/meetingEvents"); // Redirect to the Meeting and events page
									  }
									  if (item === "Gallery") {
										scroller.scrollTo("gallery-section", {
									  duration: 800, 
										 delay: 0,
									  smooth: "easeInOutQuart", 
									  });
									}
								}}
							sx={{
								fontWeight: 500,
								padding: '10px 15px',
								transition: 'all 0.3s ease',
								'&:hover': {
									color: '#fff',
									backgroundColor: '#008345',
									boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
								},
							}}
							style={{
								fontFamily: 'SangBleu Empire Trial',
								fontWeight: 'bold',
							}}>
							{item}
						</Typography>
					))}

					<Button
						sx={{
							//  color: "black",
							fontFamily: 'SangBleu Empire Trial',
							fontWeight: 'bold',

							//  padding: "10px 15px",
							transition: 'all 0.3s ease',
							backgroundColor: '#008345',
							textTransform: 'none',
							color: 'white',
							textAlign: 'left',
							borderRadius: 0,
							'&:hover': {
								//  color: "#fff",
								backgroundColor: '#008345',
								// borderRadius: "4px",
								boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
							},
						}}
						style={{ fontWeight: 900 }}
						onClick={toggleContactModal(true)}>
						Contact
					</Button>
				</Box>
			</Drawer>

			{/* Full-screen Banner Carousel */}
			<Box
				sx={{
					height: '100vh',
					overflow: 'hidden',
					position: 'relative',
				}}>
				<Slider {...settings}>
					{banners.map((banner, index) => (
						<Box
							key={index}
							component='img'
							src={banner}
							alt={`Banner ${index + 1}`}
							sx={{
								width: '100%',
								height: '100vh',
								objectFit: 'cover',
							}}
						/>
					))}
				</Slider>

				{/* Banner Text Section */}
				<Box
					sx={{
						position: 'absolute',
						left: '50%', // Center horizontally
						width: { xs: '80%', sm: '75%', md: '60%' }, // Adjust width for responsiveness
						transform: 'translateX(-50%)', // Center horizontally
						backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent background
						backdropFilter: 'blur(5px)', // Blur effect
						// border: '0.5px solid white', // Add white border
						// borderRadius: '8px',
						px: { xs: '16px', sm: '30px' }, // Adjust padding for smaller screens
						py: '20px',
						display: 'flex',
						flexDirection: 'column', // Stack vertically on all screens
						alignItems: 'center',
						top: { xs: '20%', md: '40%' }, // Adjust vertical positioning for small screens
						gap: { xs: '8px', sm: '16px' }, // Adjust gap for smaller screens
					}}>
					{/* Title text with responsive font size */}
					<Typography
						sx={{
							color: '#fff',
							fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' }, // Responsive font size
							fontWeight: 'bold',
							textAlign: 'center',
							lineHeight: '1.2', // Ensures the text has a balanced height for readability
							letterSpacing: '1px', // Slight spacing between letters for readability
							fontFamily: 'SangBleu Empire Trial',
						}}>
						Hotel City Plaza International
					</Typography>

					{/* Description Text */}
					<small
						style={{
							color: '#fff', // White text color for better contrast
							fontSize: '1rem', // Set font size for the description text
							lineHeight: '1.5', // Add space between lines for readability
							maxWidth: '100%', // Ensure text does not overflow
							fontFamily: 'SangBleu Empire Trial',
						}}>
						Hotel City Plaza International is the best Residential Hotel in
						Jessore, Bangladesh. Locating in the center of the city with
						shopping complex, Conference Hall, Rooftop Garden Barbecue
						Restaurant.
					</small>
				</Box>

				{/* Date Picker Section */}
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<Box
						sx={{
							position: 'absolute',
							left: '50%', // Center horizontally
							width: { xs: '90%', sm: '80%', md: '70%' }, // Adjust width for smaller screens
							transform: 'translateX(-50%)', // Center horizontally
							backgroundColor: 'rgba(0, 0, 0, 0.3)', // Semi-transparent background
							backdropFilter: 'blur(5px)', // Blur effect
							// border: '0.2px solid white', // Add white border
							borderRadius: '8px',
							px: { xs: '16px', sm: '30px' }, // Adjust padding for smaller screens
							py: '20px',
							display: 'flex',
							flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on smaller screens, horizontally on larger screens
							alignItems: 'center',
							top: { xs: '50%', md: '70%' }, // Adjust vertical positioning for small screens
							gap: { xs: '8px', sm: '16px' }, // Adjust gap for smaller screens
						}}>
						
						{/* Check-in Date */}
						<Box
							sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
							<Typography
								sx={{ color: '#fff', marginBottom: '8px', fontWeight: 'bold', fontFamily: 'SangBleu Empire Trial', }}>
								Check-in Date
							</Typography>
							<DatePicker
								label='Check-in Date'
								value={checkInDate}
								onChange={newValue => setCheckInDate(newValue)}
								renderInput={params => (
									<TextField
										{...params}
										sx={{
											'.MuiInputBase-root': {
												backgroundColor: '#008345',
												color: '#fff',
												borderRadius: '4px',
											},
											'.MuiInputBase-input': { color: '#fff' },
											'.MuiOutlinedInput-notchedOutline': { border: 'none' },
										}}
										fullWidth
									/>
								)}
							/>
						</Box>

						{/* Check-out Date */}
						<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
  <Typography
    sx={{
      color: '#fff',
      marginBottom: '8px',
      fontWeight: 'bold',
      fontFamily: 'SangBleu Empire Trial',
    }}
  >
    Check-out Date
  </Typography>
  <DatePicker
    label="Check-out Date"
    value={checkOutDate}
    onChange={(newValue) => setCheckOutDate(newValue)}
    renderInput={(params) => (
      <TextField
        {...params}
        sx={{
          '.MuiInputBase-root': {
            backgroundColor: '#008345',
            color: '#fff',
            borderRadius: '4px',
          },
          '.MuiInputBase-input': { color: '#fff' },
          '.MuiOutlinedInput-notchedOutline': {
            border: '1px solid red', // Red border color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'red', // Red border on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'red', // Red border when focused
          },
        }}
        fullWidth
      />
    )}
  />
						</Box>


						{/* Check Availability Button */}
						<StyledButton
							sx={{
								fontFamily: 'SangBleu Empire Trial',
								width: '80%',
								mt: { xs: '12px', sm: '0', md: '32px' },
								px: { md: '0px' },
							}}>
							Check Availability
						</StyledButton>
					</Box>
				</LocalizationProvider>
			</Box>
		</>
	);
};

export default Banner;
